import { render, staticRenderFns } from "./ProgramWebinarsCard.vue?vue&type=template&id=0fe926b8"
import script from "./ProgramWebinarsCard.vue?vue&type=script&lang=ts"
export * from "./ProgramWebinarsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports